import { render, staticRenderFns } from "./ConfigurationHealthManagementAreasGrid.vue?vue&type=template&id=2ec06f8e&"
import script from "./ConfigurationHealthManagementAreasGrid.vue?vue&type=script&lang=js&"
export * from "./ConfigurationHealthManagementAreasGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports